export const profilesTitle = "Ici Apartments and Rooms ";
